import {
  formatDenominatedNumber,
  getFarmContractName,
  getFarmPartnerLevel
} from 'helpers/mvx/formatters';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export const FarmParameters = ({ address }: { address?: string }) => {
  const rawVestaConfig = useSelector(
    (state: RootState) => state.rawVesta.config
  );

  const dataPairComponent = (left: string, right: string | number) => {
    return (
      <div className='d-flex justify-content-between'>
        <span>{left}</span>
        <span>{right}</span>
      </div>
    );
  };

  return (
    <div className='card'>
      <div className='card-header'>
        Farm Details {getFarmContractName(address ?? '')}
      </div>
      {address === undefined && (
        <div className='card-body'>
          <div className='text-center'>
            Click on an address from Farm Addresses to load its info
          </div>
        </div>
      )}

      {address !== undefined && (
        <>
          <div className='card-body'>
            <div className='mb-3 w-100 text-center'>
              <a
                href={`https://explorer.multiversx.com/accounts/${address}`}
                rel='noreferrer'
                target='_blank'
              >
                See on explorer
              </a>
            </div>
            {dataPairComponent('Partner level', getFarmPartnerLevel(address))}
            {dataPairComponent(
              'vEGLD balance',
              `${formatDenominatedNumber(
                rawVestaConfig.data?.parameters[address].vegld_balance ?? '0'
              )} vEGLD`
            )}
            {dataPairComponent(
              'Tier X',
              rawVestaConfig.data?.parameters[address].is_tier_x
                ? 'true'
                : 'false'
            )}
            {dataPairComponent(
              'Pool weight',
              `${formatDenominatedNumber(
                rawVestaConfig.data?.parameters[address].pool_weight ?? '0'
              )}x`
            )}
            {dataPairComponent(
              'Pool Density',
              `${formatDenominatedNumber(
                rawVestaConfig.data?.parameters[address].density_multiplier ??
                  '0'
              )}x`
            )}
            {dataPairComponent(
              'Tier Multiplier',
              `${formatDenominatedNumber(
                rawVestaConfig.data?.parameters[address].tier_multiplier ?? '0'
              )}x`
            )}
            {dataPairComponent(
              'Personal Multiplier (PM)',
              `${formatDenominatedNumber(
                rawVestaConfig.data?.parameters[address].personal_multiplier ??
                  '0'
              )}x`
            )}
            {dataPairComponent(
              'Public Multiplier (LM)',
              `${formatDenominatedNumber(
                rawVestaConfig.data?.parameters[address].liquidity_multiplier ??
                  '0'
              )}x`
            )}
            {dataPairComponent(
              'Diamond Multiplier',
              `${formatDenominatedNumber(
                rawVestaConfig.data?.parameters[address].diamond_multiplier ??
                  '0'
              )}x`
            )}
          </div>
          <div className='card-footer'>
            {dataPairComponent(
              'Total multiplier',
              `${formatDenominatedNumber(
                rawVestaConfig.data?.parameters[address].total_multiplier ?? '0'
              )}x`
            )}
          </div>
        </>
      )}
    </div>
  );
};
